// extracted by mini-css-extract-plugin
export default {"fold":"DashboardGrid_fold__6K66K","stack":"DashboardGrid_stack__U+Hpn","row":"DashboardGrid_row__P6Aob","even":"DashboardGrid_even__27Y86"};